import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';

export const DashboardTransactionsDynamicSummarySkeleton: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      gap: '12px',
      flexDirection: 'column',
      padding: '16px',
      borderRadius: '8px',
      backgroundColor: '#fff',
    }}
  >
    <Stack direction="column">
      <Skeleton height={24} variant="text" width="80%" />
      <Skeleton height={20} variant="text" width="60%" />
    </Stack>
    <Skeleton height={456} variant="rounded" width="100%" />
  </Box>
);
